export default __webpack_public_path__ + "static/media/support.1c93950a.webp";